import { PaymentMethod, PaymentRequest } from '../types';

export const getDefaultPaymentMethods = (): PaymentMethod[] => [
  {
    id: 'stripe',
    name: 'Kreditkarte',
    icon: '💳',
    description: 'Visa, Mastercard, American Express',
    available: true,
    processingFee: 0,
  },
  {
    id: 'cash',
    name: 'Bargeld',
    icon: '💵',
    description: 'Zahlung vor Ort',
    available: true,
    processingFee: 0,
  },
];

export const calculateTotalWithFees = (amount: number, method: PaymentMethod): number =>
  amount + (amount * (method.processingFee || 0)) / 100;

/** Ruft die Supabase Edge Function auf und gibt clientSecret + paymentIntentId zurück */
export const createPaymentIntent = async (
  request: PaymentRequest
): Promise<{ clientSecret: string; paymentIntentId: string }> => {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  const anonKey    = import.meta.env.VITE_SUPABASE_ANON_KEY;

  const res = await fetch(`${supabaseUrl}/functions/v1/create-payment-intent`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${anonKey}`,
    },
    body: JSON.stringify({
      amount:        request.amount,
      currency:      'chf',
      bookingId:     request.booking_id,
      serviceId:     request.service_id,
      paymentMethod: 'card',
    }),
  });

  const data = await res.json();
  if (!res.ok || data.error) throw new Error(data.error || 'PaymentIntent konnte nicht erstellt werden');
  return { clientSecret: data.clientSecret, paymentIntentId: data.paymentIntentId };
};

export const formatCurrency = (amount: number, currency = 'CHF'): string =>
  new Intl.NumberFormat('de-CH', { style: 'currency', currency }).format(amount);
